var _rect, _path, _path2, _path3, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkdnicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70.67 70.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70.67,
    height: 70.67,
    fill: "#000",
    strokeWidth: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.78,51.67h-8.27v-26.65h7.93v3.55c.57-.67,1.06-1.34,1.65-1.9,1.46-1.38,3.24-2.09,5.23-2.28,1.71-.16,3.42-.03,5.07.48,2.76.86,4.38,2.8,5.19,5.5.54,1.79.73,3.64.74,5.5.03,5.16.02,10.32.03,15.48,0,.06-.01.13-.02.23h-8.28c0-.19,0-.38,0-.57,0-4.41,0-8.82-.02-13.24,0-.92-.09-1.86-.26-2.76-.5-2.74-2.28-3.69-4.86-3.38-2.31.28-3.58,1.65-3.93,4.16-.13.92-.19,1.85-.19,2.77-.02,4.17,0,8.34,0,12.5,0,.19,0,.38,0,.6Z",
    fill: "#fff",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.25,51.67h-8.24v-26.67h8.24v26.67Z",
    fill: "#fff",
    strokeWidth: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.92,16.46c.01,2.65-2.14,4.85-4.76,4.87-2.64.02-4.84-2.19-4.84-4.85,0-2.62,2.15-4.78,4.77-4.81,2.65-.02,4.81,2.13,4.83,4.79Z",
    fill: "#fff",
    strokeWidth: 0
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 63.91,
    width: 70.67,
    height: 6.76,
    fill: "#785abf",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkdnicon);
export default __webpack_public_path__ + "static/media/linkdnicon.2a4f2c8d9eba3829774479925b69e571.svg";
export { ForwardRef as ReactComponent };